import {EmployeeFull, TeamWithCountsNew} from 'client';

/** The person's teams, most of their time first, then biggest, then by name. */
export const sortEmployeeTeams = (
  employee: Pick<EmployeeFull, 'team_associations'>,
  employeeTeams: TeamWithCountsNew[] | null | undefined
): TeamWithCountsNew[] => {
  if (!employeeTeams?.length) {
    return [];
  }

  const allocationByTeamId = new Map(
    (employee.team_associations ?? []).map((association) => [
      association.team.team_id,
      association.allocation,
    ])
  );

  return [...employeeTeams].sort((teamA, teamB) => {
    const allocationA = allocationByTeamId.get(teamA.team_id) ?? -1;
    const allocationB = allocationByTeamId.get(teamB.team_id) ?? -1;

    if (allocationA !== allocationB) {
      return allocationB - allocationA;
    }

    if (teamA.total_employee_count !== teamB.total_employee_count) {
      return teamB.total_employee_count - teamA.total_employee_count;
    }

    return (teamA.name ?? '').localeCompare(teamB.name ?? '');
  });
};
